import DBOperationsComb from "src/utils/dbOperationsComb";
import Constants from "src/utils/constants";
import Exception from "src/utils/exception";

async function insertAttachment(data) {
  try {
    return await DBOperationsComb.insertData(
      Constants.enums.TABLES_NAME_ENUM.ATTACHMENTS_TABLE,
      data,
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getAttachment(id, getLocalAttachments = false) {
  try {
    return await DBOperationsComb.getData(
      Constants.enums.TABLES_NAME_ENUM.ATTACHMENTS_TABLE,
      id,
      getLocalAttachments
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  insertAttachment,
  getAttachment
};
